import JobOffers from './joboffers'

export default JobOffers